import React from 'react'

const SendHistoriquePush = ({ messagesPush, setTitleHistory, setMessageHistory }) => {
    return (
        <div className='border-bottom pb-3'>
            {messagesPush &&
                messagesPush.sort((a,b) => a.dateInt < b.dateInt ? 1 : -1).map(m => (
                    <div className='row border-top mt-3 pt-3' key={m.id}>
                        <div className='col'>
                            <div>{m.title}  {m.message}</div>
                            <div>{m.date}</div>
                        </div>
                        <div 
                            className='col text-end align-self-center' 
                            style={{ cursor:'pointer' }}
                            onClick={() => [setTitleHistory(m.title), setMessageHistory(m.message)]}
                        >
                            <u data-bs-toggle="modal" data-bs-target="#modalConfirmSendHistoryPush">Renvoyer</u>
                        </div>
                    </div>
                ))
            }   
        </div>
    )
}

export default SendHistoriquePush
